import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 30, height: 20, viewBox: "0 0 15 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.14282 5.71429L5.71447 9.28594L12.8571 2.14258", stroke: "black", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
